// extracted by mini-css-extract-plugin
export default {"page":"GameCardPage_page__hzfAZ","page_container":"GameCardPage_page_container__E3C9y","loading":"GameCardPage_loading__noryI"};